import axios from 'axios'
import config from '../../../config'

let SleepApi = {
  getFitBitSleepLog(beforeDate) {
    return axios.get(config.apiUrl + 'integration/fitbit/sleep/log/' + beforeDate);
  },
  getFitBitData(date) {
    return axios.get(config.apiUrl + 'integration/fitbit/sleep/' + date)
  },
  getStriivData(date) {
    return axios.get(config.apiUrl + 'integration/striiv/sleep/' + date);
  },
  getSleepTrackingDetail(page, page_size) {
    return axios.get(config.apiUrl + 'tracking/sleep/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    })
  },
  getSleepTrackingWearableDetail(page, page_size) {
    return axios.get(config.apiUrl + 'tracking/sleep/wearable/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    })
  },
  getSleepTrackingCard() {
    return axios.get(config.apiUrl + 'tracking/sleep/card/?requestFrom=web');
  },
  postSleepTracking(model) {
    return axios.post(config.apiUrl + 'tracking/sleep/', model);
  },
  putSleepTracking(model) {
    return axios.put(config.apiUrl + 'tracking/sleep/', model);
  },
  deleteSleepTracking(progressId, trackingId) {
    return axios.delete(config.apiUrl + 'tracking/sleep/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    })
  }
};

export default SleepApi



// WEBPACK FOOTER //
// ./src/api/Tracking/Sleep/index.js